export default __webpack_public_path__ + "static/media/012-nepal.d5cd3ac4.svg";